module.exports = __webpack_public_path__ + "img/cg_sea.543fbfb7.jpg";